import { defineComponent as _defineComponent } from 'vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import store from '@/store'
import { i18n } from '@/locale/vueI18n'
import FleetState from './FleetState.vue'
import { computed, getCurrentInstance, ref } from 'vue'
import { VuetifyConfirmObject } from 'vuetify-confirm/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetLine',
  props: {
  fleet: {
    type: AloDbFleet,
    required: true
  }
},
  setup(__props) {

const props = __props;

const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm!



const deleting = ref(false)

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const accesPilotReachDetail = computed(() => {
  return props.fleet.security[SecurityItemsKeys.PILOT_REACH_DETAIL]
})

const detailVisibility = computed(() => {
  return {}
})

async function deleteFleet() {
  if (!deleting.value) {
    const answer = await $confirm(i18n.t('Fleet.DeleteDialogMessage', { name: props.fleet.FLE_LIBELLE }).toString(), {
      title: i18n.t('Admin.Warning')
    } as VuetifyConfirmObject)
    if (answer) {
      //@ts-ignore
      deleting.value = true
      try {
        await store.myActions.ADMINFLEET_DELETE_REQUEST(props.fleet)
      } finally {
        deleting.value = false
      }
    }
  }
}

return { __sfc: true,instance, $confirm, props, deleting, fleetIco, accesPilotReachDetail, detailVisibility, deleteFleet, FleetState }
}

})